/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentSalesAnalyzeMonitorEditRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.sales.analyze.monitor.edit',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentSalesAnalyzeMonitorEditRoute);
